import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Typography, Button } from "@material-ui/core";
import { MobileCardItem, MobileDialogCampusCalendarCheckAttendance, MobileDialogCampusCalendarAddAttendance } from "../../../../";
import { makeStyles } from "@material-ui/styles";
import moment from "moment";
var useStyles = makeStyles(function (theme) {
  return {
    my12: {
      margin: "12px 0"
    },
    breadcrumb: {
      display: "flex",
      flexFlow: "row nowrap",
      alignItems: "center",
      justifyContent: "flex-end",
      height: "60px",
      position: "fixed",
      width: "100%",
      zIndex: "10",
      background: theme.palette.background["default"]
    },
    content: {
      margin: "68px 8px 8px 8px"
    }
  };
});

var MobileCampusCalendarTabAttendance = function MobileCampusCalendarTabAttendance(props) {
  // console.log("MobileCampusCalendarTabAttendance props", props);
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openDialogAddAttendance = _useState2[0],
      setOpenDialogAddAttendance = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openDialogCheckAttendance = _useState4[0],
      setOpenDialogCheckAttendance = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      attendanceSelected = _useState6[0],
      setAttendanceSelected = _useState6[1];

  var classes = useStyles(); // HANDLE DIALOG

  var handleDialogAddAttendance = function handleDialogAddAttendance() {
    setOpenDialogAddAttendance(!openDialogAddAttendance);
  };

  var handleDialogCheckAttendance = function handleDialogCheckAttendance() {
    if (openDialogCheckAttendance) {
      setAttendanceSelected(null);
    }

    setOpenDialogCheckAttendance(!openDialogCheckAttendance);
  };

  var handleClickCheckAttendance = function handleClickCheckAttendance(idAttendance, childKey, date) {
    // console.log("handleClickCheckInAttendance", idAttendance, childKey, date);
    // console.log("props.data.arrAttendance", props.data.arrAttendance);
    var _attendance = props.data.arrAttendance.find(function (el) {
      return el.date === date;
    }).childrenAttendance[childKey].find(function (at) {
      return at._id === idAttendance;
    }); // console.log("_attendance", _attendance);


    setAttendanceSelected(_attendance);
    handleDialogCheckAttendance();
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MobileDialogCampusCalendarAddAttendance, {
    open: openDialogAddAttendance,
    onClose: handleDialogAddAttendance,
    children: props.data ? props.data.children || [] : [],
    onSubmit: props.data.handleAddAttendance,
    translation: props.translation ? props.translation.dialogs.add_attendance : null
  }), /*#__PURE__*/React.createElement(MobileDialogCampusCalendarCheckAttendance, {
    open: openDialogCheckAttendance,
    onClose: handleDialogCheckAttendance,
    data: attendanceSelected,
    translation: props.translation ? props.translation.dialogs.check_attendance : null
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.breadcrumb
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    color: "primary",
    onClick: function onClick() {
      props.data.handleDownloadChildrenInfo().then(function (x) {
        handleDialogAddAttendance();
      });
    }
  }, props.translation ? props.translation.buttons ? props.translation.buttons.notify_attendance || "Notify attendance" : "Notify attendance" : "Notify attendance")), /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, props.data ? props.data.arrAttendance.map(function (day) {
    // console.log("day in library", day);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, day.date), Object.keys(day.childrenAttendance).map(function (key) {
      //para cada niño en ese día
      var _groups = day.childrenAttendance[key];
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1"
      }, _groups[0].child.name), _groups.map(function (_gr) {
        // para cada grupo al que asiste el niño en ese dia
        return /*#__PURE__*/React.createElement(MobileCardItem, {
          template: "calendarAttendanceListParent",
          data: _objectSpread(_objectSpread({}, _gr), {}, {
            handleClickCheckAttendance: handleClickCheckAttendance
          }),
          classes: classes.my12,
          translation: props.translation ? props.translation.card_item : null
        });
      }));
    }));
  }) : null));
};

export { MobileCampusCalendarTabAttendance };